import { render, staticRenderFns } from "./ResponsiveImg.vue?vue&type=template&id=b842080e&scoped=true"
import script from "./ResponsiveImg.vue?vue&type=script&lang=js"
export * from "./ResponsiveImg.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveImg.vue?vue&type=style&index=0&id=b842080e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b842080e",
  null
  
)

export default component.exports